import { Routes } from '@angular/router';
import { PageTitleEnum } from '@shared/enums';
import { userGuard } from '@core/guards';

export const ordersRoutes: Routes = [
    {
        path: '',
        loadComponent: () => import('./_orders-layout/orders-layout.component').then(mod => mod.OrdersLayoutComponent),
        children: [
            {
                path: '',
                redirectTo: 'my-orders',
                pathMatch: 'full',
            },
            {
                path: 'my-orders',
                loadComponent: () =>
                    import('./order-listing/order-listing.component').then(mod => mod.OrderListingComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_LISTING,
                data: { preload: true },
            },
            {
                path: 'wellplate-storage',
                loadComponent: () =>
                    import('./wellplate-storage/wellplate-storage.component').then(
                        mod => mod.WellplateStorageComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_WELLPLATE_STORAGE,
            },
            {
                path: 'faq',
                loadComponent: () => import('./order-faq/order-faq.component').then(mod => mod.OrderFaqComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_FAQ,
            },
            {
                path: 'results-availability-schedule',
                loadComponent: () =>
                    import(
                        './results-availability-schedule/results-availability-schedule-page/results-availability-schedule-page.component'
                    ).then(mod => mod.ResultsAvailabilitySchedulePageComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.ORDER_RESULTS_AVAILABILITY_SCHEDULE,
            },
        ],
    },
];
